<template>
  <b-row>
    <!-- Certificate -->
    <b-col
      cols="12"
      md="4"
    >
      <b-form-group
        label="Certificate"
        label-for="certificate"
      >
        <b-form-select
          :options="mainC"
          :value="computedSelectedCertificate"
          placeholder="Select By certificate"
          @change="handleChangeSelect($event, 'certificate')"
        />
      </b-form-group>
    </b-col>

    <!-- Engineer -->
    <b-col
      cols="12"
      md="4"
    >
      <b-form-group
        label="Engineer"
        label-for="engineer"
      >
        <v-select
          :options="optionsEmployee"
          :value="selectedEngineer"
          trim
          @input="handleChangeSelect($event, 'user')"
        />
      </b-form-group>
    </b-col>

    <!-- Active User -->
    <b-col
      cols="12"
      md="1"
      class="d-flex align-items-center"
    >
      <b-form-checkbox
        id="active-user"
        :checked="activeUser"
        @input="handleChangeSelect($event, 'active-user')"
      >
        Active User
      </b-form-checkbox>
    </b-col>

    <!-- RESET & RELOAD -->
    <b-col
      cols="12"
      md="3"
      class="d-flex align-items-center justify-content-end"
    >
      <b-button
        variant="outline-danger"
        class="mr-50"
        title="Reset Filters"
        @click="resetFilters"
      >
        <span class="text-nowrap">Reset</span>
      </b-button>
      <b-button
        variant="outline-primary"
        title="Force Refresh Data from Server"
        @click="$emit('reload-server-data')"
      >
        <span class="text-nowrap">Reload Data</span>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: { vSelect },

  props: {
    mainCols: {
      type: Array,
      default: () => [],
    },

    activeUser: {
      type: Boolean,
      default: () => false,
    },

    selectedCertificate: {
      type: Number,
      default: () => null,
    },

    userValue: {
      type: Number,
      default: () => null,
    },
    productValue: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      loadingProducts: false,
    }
  },

  computed: {
    mainC() {
      const options = this.mainCols.map(item => ({
        value: item.id,
        text: item.name,
      }))
      return [{ value: null, text: 'All Certificates' }, ...options]
    },

    computedSelectedCertificate() {
      return Number(this.$route.query.certificate) || null
    },

    optionsEmployee() {
      return this.$store.getters['generalData/engineersList/engineersList']
    },

    optionsProducts() {
      const key = this.computedSelectedCertificate || 'all'
      return this.$store.getters['generalData/productsInCertificate/getProductsById'](key)
    },

    selectedProduct() {
      const raw = this.$route.query.product
      if (!raw) return []
      const names = raw.split(',')
      return this.optionsProducts.filter(p => names.includes(p.value))
    },

    selectedEngineer() {
      const id = Number(this.$route.query.user)
      return this.optionsEmployee.find(e => e.value === id) || null
    },
  },

  watch: {
    computedSelectedCertificate: {
      immediate: true,
      async handler(newVal) {
        this.loadingProducts = true
        try {
          if (newVal) {
            await this.$store.dispatch('generalData/productsInCertificate/fetchProducts', newVal)
          } else {
            await this.$store.dispatch('generalData/productsInCertificate/fetchAllProducts')
          }
        } finally {
          this.loadingProducts = false
        }
      },
    },
  },

  async mounted() {
    if (!this.$store.getters['generalData/engineersList/engineersLoaded']) {
      await this.$store.dispatch('generalData/engineersList/fetchEngineersList')
    }
    if (!this.$store.getters['generalData/productList/productListLoaded']) {
      await this.$store.dispatch('generalData/productList/fetchProductList')
    }
  },

  methods: {
    handleChangeSelect(value, type) {
      const newQuery = { ...this.$route.query }

      if (type === 'certificate') {
        newQuery.certificate = value
        newQuery.product = null
      }
      if (type === 'user') newQuery.user = value?.value
      if (type === 'product') {
        newQuery.product = Array.isArray(value) && value.length
          ? value.map(v => v.value).join(',')
          : null
      }
      if (type === 'active-user') newQuery.active = value

      this.$router.push({ query: newQuery })

      this.$emit('change-select', value, type)
    },

    resetFilters() {
      this.$router.replace({ query: {} }).catch(() => {})
      this.$nextTick(() => {
        this.$emit('reset-all')
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
